import { atom } from 'recoil';

export const errorState = atom<any>({
  key: "errorState",
  default:[]
});
